import { render, staticRenderFns } from "./vipSpecial.vue?vue&type=template&id=2635402a&scoped=true"
import script from "./vipSpecial.vue?vue&type=script&lang=js"
export * from "./vipSpecial.vue?vue&type=script&lang=js"
import style0 from "./vipSpecial.vue?vue&type=style&index=0&id=2635402a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2635402a",
  null
  
)

export default component.exports